<ion-header *ngIf="!showEmbedElt">
  <top-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header>

<ion-content>
  <bloc-header-comp [compOptions]="{'title': blocHeaderTitle, 'isBackBtn': true, url: blocHeaderBackUrl}"></bloc-header-comp>

  <ng-template #offerCard let-card="card" let-special="special" let-embed="embed">
    <div [ngClass]="{'evs-card': !special || (special && !isDesktop), 'evs-card-ui': special && isDesktop, 'special-offer': special, 'force-width100': card.forceWidth100}" (click)="openLink(card.link, {'offerId': card.id, 'offerType': card.offer_type, 'offerMinQuantity': card.min_quantity, 'specialClicked': special})">
      <div *ngIf="special && !hasPromoCard" class="special-title">Meilleure offre</div>
      <div *ngIf="special && hasPromoCard" class="special-title">PROMO</div>
      <div class="wpe-100" [ngClass]="{'special-text-container': special, 'embed': embed}">
        <!-- BASE CARD -->
        <ng-container *ngIf="!special">
          <div *ngIf="embed" class="icon-container">
            <img *ngIf="switchOffers === 'BVM'" [src]="'assets/svg/Icon_play_hiorange.svg'">
            <img *ngIf="switchOffers === 'BVA'" [src]="'assets/svg/Icon_play_blue.svg'">
          </div>
          <div class="text-container">
            <div class="card-text-wrapper">
              <div *ngIf="!!card.title" class="card-title">{{ card.title }}</div>
              <div *ngIf="!!card.description" class="card-desc">{{ card.description }}</div>
              <div *ngIf="!!card.text" class="card-text">{{ card.text }}</div>
            </div>
            <div *ngIf="card.amount !== null" class="card-price-wrapper">
              <div *ngIf="card.amount !== null" class="card-price" [ngClass]="{'text-danger': card.promo}">{{ card.transformed_amount }}</div>
              <del *ngIf="!!card.price_desc" class="card-del-price">{{ card.transformed_price_desc }}</del>
            </div>
          </div>
        </ng-container>
        <!-- SPECIAL CARD -->
        <ng-container *ngIf="special">
          <div class="text-container">
            <!-- DESKTOP -->
            <ng-container *ngIf="isDesktop">
              <div class="card-text-wrapper">
                <div *ngIf="!!card.title" class="card-title">
                  <span class="scribble-circle">{{card.title}}</span>
                  <span class="scribble-dash"></span>
                </div>
                <div *ngIf="!!card.description" class="card-desc">{{ card.description }}</div>
                <div *ngIf="!!card.text" class="card-text">{{ card.text }}</div>
              </div>
              <div *ngIf="card.amount !== null" class="card-price-wrapper">
                <div class="promo-badge">Offre spéciale</div>
                <div *ngIf="card.amount !== null" class="card-price" [ngClass]="{'text-danger': card.promo}">{{ card.transformed_amount }}</div>
                <del *ngIf="!!card.price_desc" class="card-del-price">{{ card.transformed_price_desc }}</del>
              </div>
            </ng-container>
            <!-- MOBILE -->
            <ng-container *ngIf="!isDesktop">
              <div class="promo-badge">Offre spéciale</div>
              <div *ngIf="!!card.title" class="card-title">{{card.title}}</div>
              <div *ngIf="!!card.description" class="card-desc">{{ card.description }}</div>
              <div *ngIf="card.amount !== null" class="card-price-wrapper">
                <div *ngIf="card.amount !== null" class="card-price" [ngClass]="{'text-danger': card.promo}">{{ card.transformed_amount }}</div>
                <del *ngIf="!!card.price_desc" class="card-del-price">{{ card.transformed_price_desc }}</del>
              </div>
              <div *ngIf="!!card.text" class="card-text">{{ card.text }}</div>
            </ng-container>
          </div>
          <span *ngIf="isDesktop" class="scribble-dot"></span>
          <span *ngIf="isDesktop" class="scribble-bubble"></span>
          <span *ngIf="isDesktop" class="scribble-triangle"></span>
        </ng-container>
        <div *ngIf="!!card.badge" class="badge bold">{{ card.badge }}</div>
      </div>
      <div *ngIf="special" class="list-container">
        <div *ngFor="let keypoint of card.key_points" ngClass="special-list-item"><img src="assets/2022/icons/checkbox-on-green.svg" alt="EnVoitureSimone"><p>{{ keypoint }}</p></div>
      </div>
      <button *ngIf="special" class="btn" (click)="openLink(card.link, {'offerId': card.id, 'offerType': card.offer_type, 'offerMinQuantity': card.min_quantity, 'specialClicked': false})">Je passe le permis</button>
      <img *ngIf="!special" class="arrow-card" src="assets/2022/icons/arrow-right-2-off.svg" alt="EnVoitureSimone">
    </div>
  </ng-template>

  <div class="ion-content-container" [ngClass]="{'bva-colors': switchOffers === 'BVA'}">
    <div *ngIf="!!pricingZone" class="zone-container content-center">
      <div class="zone-title">
        Profite de nos packs pour conduire dans cette zone
      </div>
      <button class="zone-btn" (click)="openModalMap()">
        <img [src]="'assets/svg/edit.svg'">
        <div class="zone-btn-txt">{{pricingZone}}</div>
      </button>
    </div>
    <modal-comp [ngClass]="{'without-cordova': !isCordova}" [compOptions]="{'id': 'customModalMap', closable: false}" *ngIf="showModalMap" (canClose)="closeModalMap(true)">
      <div *ngIf="!student.isGuest()" class="close-modal-button clickable" (click)="closeModalMap(true)">
        <img src="assets/2022/icons/close-off.svg" alt="EnVoitureSimone" height="24">
      </div>
        <div class="map-text">Où souhaites-tu réaliser des leçons de conduite ?</div>
        <div class="map-bloc padding-bottom-24">
          <div class="modal-offers-switch-wrapper">
            <div class="switch-selector" [ngClass]="{'manual-selected': switchOffers === 'BVM', 'automatic-selected': switchOffers === 'BVA'}"></div>
            <button [ngClass]="{'selected-offer-type': switchOffers === 'BVM'}" (click)="setOffersDisplay('BVM', true)">Boîte manuelle</button>
            <button *ngIf="isDesktop" [ngClass]="{'selected-offer-type': switchOffers === 'BVA'}" (click)="setOffersDisplay('BVA', true)">Boîte automatique</button>
            <button *ngIf="!isDesktop" [ngClass]="{'selected-offer-type': switchOffers === 'BVA'}" (click)="setOffersDisplay('BVA', true)">Boîte auto</button>
          </div>
          <div class="map-input">
            <form class="evs-form">
              <div class="margin-bottom-0">
                <input id="geoloc-input" type="text" name="geoloc-input" autocomplete="off" data-lpignore="true" (input)="checkUserInputValue()">
                <label for="geoloc-input" [ngClass]="{'label-up': userIsTyping || placeLocationsSent}">Renseigner mon adresse</label>
              </div>
              <!-- <div class="geoloc-btn" (click)="showCurrentLocation()">
                <img *ngIf="!geolocationLoading && !placeLocationsSent && !userIsTyping" src="assets/svg/geolocation-v2.svg" alt="EnvoitureSimone">
                <span *ngIf="geolocationLoading">
                  <ion-spinner class="btn-spinner" name="lines-small"></ion-spinner>
                </span>
              </div> -->
              <div *ngIf="placeLocationsSent || userIsTyping" class="delete-btn small-clickable" (click)="cleanMap()">
                <img src="assets/svg/tunnel-delete-ico.svg" alt="EnvoitureSimone">
              </div>
            </form>
          </div>
          <div class="map-km" *ngIf="isLocationFar">
            <p *ngIf="switchOffers === 'BVM'">Il n'y a pas encore de points de RDV en <span class="bold">boîte manuelle</span> à moins de 15km de chez toi, le plus proche se trouve à :</p>
            <p *ngIf="switchOffers === 'BVA'">Il n'y a pas encore de points de RDV en <span class="bold">boîte automatique</span> à moins de 15km de chez toi, le plus proche se trouve à :</p>
            <div class="map-city">
              <img src="https://app.envoituresimone.com/assets/png/pin-active.png" alt="EnvoitureSimone"> <p>{{userNearestLocation}}</p>
            </div>
          </div>
          <div #gMap class="map" [ngClass]="{'gray-map': userAddress === ''}"></div>
        </div>
        <div class="map-cta">
          <button class="btn full-width margin-bottom-8" (click)="changeUserCP()" [disabled]="userAddress === '' || mapLoading">Valider</button>
          <a [href]="'tel:0173148153'" class="btn light full-width" *ngIf="isLocationFar">Nous appeler - 01 73 14 81 53</a>
        </div>
    </modal-comp>

    <div *ngIf="!cardsDone" class="wpe-100 offers-containers content-center flex-column">
      <div *ngFor="let group of utils.numberToArray(3); let i = index" class="wpe-100 padding-10" [ngClass]="{'animated fadeIn': (!isCordova && !isMobile)}">
        <div class="wpi-150 border-radius-6 padding-8 margin-bottom-30 dark-shimmer" [ngClass]="{'margin-top-20': i > 0}"></div>
        <div *ngFor="let card of utils.numberToArray(1); let ix = index" [ngClass]="{'force-width100': (ix == 0 && i == 0) || (ix == 0 && i == 2)}" class="wpe-100 evs-card evs-card-big-dashboard content-center flex-column" [ngStyle]="{'align-items': 'flex-start'}">
          <div class="wpe-40 border-radius-6 padding-8 margin-8 margin-bottom-10 shimmer"></div>
          <div class="wpe-70 border-radius-6 padding-6 margin-6 shimmer"></div>
          <div class="wpe-50 border-radius-6 padding-6 margin-6 margin-bottom-10 shimmer"></div>
          <div class="wpe-50 border-radius-6 padding-8 margin-8 shimmer"></div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="cardsDone">
      <div class="offers-switch-wrapper">
        <div class="switch-selector" [ngClass]="{'manual-selected': switchOffers === 'BVM', 'automatic-selected': switchOffers === 'BVA'}"></div>
        <button [ngClass]="{'selected-offer-type': switchOffers === 'BVM'}" (click)="setOffersDisplay('BVM')">Boîte manuelle</button>
        <button *ngIf="isDesktop" [ngClass]="{'selected-offer-type': switchOffers === 'BVA'}" (click)="setOffersDisplay('BVA')">Boîte automatique</button>
        <button *ngIf="!isDesktop" [ngClass]="{'selected-offer-type': switchOffers === 'BVA'}" (click)="setOffersDisplay('BVA')">Boîte auto</button>
      </div>

      <ng-container *ngFor="let offerType of builtOfferCards">
        <ng-container *ngIf="offerType.id === switchOffers">

          <!-- SPECIAL OFFERS -->
          <div *ngIf="offerType.specialOffers.length > 0"  class="offers-containers special">
            <ng-container *ngFor="let card of offerType.specialOffers" [ngTemplateOutlet]="offerCard" [ngTemplateOutletContext]="{card: card, special: true, embed: false}"></ng-container>
          </div>

          <!-- CALL CENTER -->
          <div class="call-center-container">
            <a class="call-center-link" [href]="'tel:' + callCenterPhoneFormatted">
              <div class="call-center-wrapper evs-card">
                <img class="call-center-img" src="assets/svg/picto_questions.svg" alt="En Voiture Simone">
                <div *ngIf="isDesktop" class="call-center-text-wrapper">
                  <div class="call-center-title">Des questions sur le Pack Permis ?</div>
                  <div class="call-center-desc">Appelle le {{ callCenterPhone }} (appel non surtaxé)</div>
                </div>
                <div *ngIf="!isDesktop" class="call-center-text-wrapper">
                  <div class="call-center-title">Des questions ?</div>
                  <div class="call-center-desc">Nos conseillers sont disponibles pour te répondre</div>
                </div>
                <img *ngIf="isDesktop && switchOffers === 'BVM'" class="call-center-icon" src="assets/svg/picto_call.svg" alt="En Voiture Simone">
                <img *ngIf="isDesktop && switchOffers === 'BVA'" class="call-center-icon" src="assets/svg/picto_call_blue.svg" alt="En Voiture Simone">
              </div>
            </a>
          </div>

          <!-- CODE OFFERS -->  
          <div *ngIf="offerType.codeOffers.length > 0" class="offers-containers">
            <div class="offer-type-title-wrapper">
              <div class="offer-type-title">{{ codeTitle }}</div>
            </div>
            <div class="cards-wrapper">
              <ng-container *ngFor="let card of offerType.codeOffers" [ngTemplateOutlet]="offerCard" [ngTemplateOutletContext]="{card: card, special: false, embed: false}"></ng-container>
            </div>
          </div>

          <!-- DRIVING OFFERS -->  
          <div *ngIf="offerType.drivingOffers.length > 0" class="offers-containers">
            <div class="offer-type-title-wrapper">
              <div class="offer-type-title">{{ drivingTitle }}</div>
              <div *ngIf="drivingSubTitle !== ''" class="offer-type-subtitle">{{ drivingSubTitle}}</div>
            </div>
            <div class="cards-wrapper">
              <ng-container *ngFor="let card of offerType.drivingOffers" [ngTemplateOutlet]="offerCard" [ngTemplateOutletContext]="{card: card, special: false, embed: false}"></ng-container>
              <ng-container [ngTemplateOutlet]="offerCard" [ngTemplateOutletContext]="{card: cardCPF, special: false, embed: false}"></ng-container>
            </div>
          </div>

          <!-- CARD VIDEO -->  
          <div *ngIf="!hasHours && !isPackPermis" class="offers-containers">
            <ng-container [ngTemplateOutlet]="offerCard" [ngTemplateOutletContext]="{card: cardWhichOfferVideo, special: false, embed: true}"></ng-container>
          </div>

        </ng-container>
      </ng-container>
    </ng-container>
  </div>
  
  <!-- MODAL OFFER NOT FOUND -->
  <modal-comp [compOptions]="{'id': 'customModalOfferNotFound'}" *ngIf="displayModalOfferNotFound" (canClose)="hideModalOfferNotFound()" #modalOfferNotFound>
    <div class="padding-10 text-center">
      <h3>Oops !</h3>
      <p>Une erreur est survenue, réessaie plus tard.</p>
    </div>
  </modal-comp>

  <div *ngIf="showEmbedElt" class="embed-video-container">
    <div class="close-btn clickable" (click)="hideModalEmbed()">
      <img src="assets/2022/icons/close-off.svg" alt="EnVoitureSimone" height="24">
    </div>
    <div class="embed-video">
      <iframe loading="lazy" [src]="embedSrc" allow="autoplay" allowfullscreen></iframe>
    </div>
  </div>

  <modal-comp [compOptions]="{'id': 'customModalNoResults', size: 'small'}" *ngIf="modalNoResults" (canClose)="hideModalNoResults()">
    <div class="text-center">
      <p>Zut, il n’y a pas encore de point de rendez-vous près de chez toi…</p>
      <button class="btn full-width" (click)="resetInput()">Chercher une autre adresse</button>
    </div>
  </modal-comp>
  
  <modal-comp [compOptions]="{'id': 'customModalNoGeoloc', size: 'small'}" *ngIf="modalNoGeoloc" (canClose)="hideModalNoGeoloc()">
    <div class="text-center">
      <p>{{noGeolocText}}</p>
      <button class="btn full-width" (click)="hideModalNoGeoloc()">J'ai compris</button>
    </div>
  </modal-comp>
  
  <modal-comp [compOptions]="{'id': 'customModalLocationError'}" *ngIf="modalLocationError" (canClose)="hideModalLocationError()">
    <div class="text-center">
      <h3>Une erreur est survenue</h3>
      <p>Nous ne sommes pas parvenus à récupérer nos points de rendez-vous. Réessaie plus tard.</p>
      <button class="btn full-width" (click)="hideModalLocationError()">J'ai compris</button>
    </div>
  </modal-comp>
  
  <modal-comp [compOptions]="{'id': 'customModalSearchError'}" *ngIf="modalSearchError" (canClose)="hideModalSearchError()">
    <div class="text-center">
      <h3>Une erreur est survenue</h3>
      <p>Nous ne sommes pas parvenus à traiter ta recherche. Réessaie plus tard.</p>
      <button class="btn full-width" (click)="hideModalSearchError()">J'ai compris</button>
    </div>
  </modal-comp>

</ion-content>

<ion-footer *ngIf="!showEmbedElt && !showModalMap">
  <footer-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer>
